import { API_ERROR_CODES, parseApiError } from "@/lib/api/api-error";

export interface AdminLoginFormValues {
  email: string;
  password: string;
}

export function isValidAdminEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

export function isAdminLoginFormValid(form: AdminLoginFormValues): boolean {
  return isValidAdminEmail(form.email.trim()) && form.password.length >= 8;
}

export function toAdminLoginRequest(form: AdminLoginFormValues) {
  return {
    email: form.email.trim(),
    password: form.password,
  };
}

export const ADMIN_LOGIN_MESSAGES = {
  invalidCredentials: "Incorrect email or password. Please try again.",
  accountDisabled: "This admin account is disabled.",
  invalidRequest: "Invalid request. Please check your credentials and try again.",
  network:
    "We couldn't reach the server. Check your connection and try again.",
  generic: "Something went wrong. Please try again later.",
} as const;

export interface AdminLoginError {
  message: string;
}

export function resolveAdminLoginError(err: unknown): AdminLoginError {
  const { status, code, message, isNetworkError } = parseApiError(err);

  if (isNetworkError) {
    return { message: ADMIN_LOGIN_MESSAGES.network };
  }

  if (status === 401) {
    return {
      message: message ?? ADMIN_LOGIN_MESSAGES.invalidCredentials,
    };
  }
  if (status === 403) {
    return {
      message: message ?? ADMIN_LOGIN_MESSAGES.accountDisabled,
    };
  }
  if (status === 400 || code === API_ERROR_CODES.invalidRequest) {
    return { message: message ?? ADMIN_LOGIN_MESSAGES.invalidRequest };
  }

  return { message: ADMIN_LOGIN_MESSAGES.generic };
}
